export function formatAPIDate(value: string | Date | null | undefined): string {
    if (!value) {
        return '';
    }

    const normalized = typeof value === 'string' && !/(Z|[+-]\d{2}:?\d{2})$/.test(value.trim())
        ? `${value.trim().replace(' ', 'T')}Z`
        : value;

    const date = normalized instanceof Date ? normalized : new Date(normalized);
    if (Number.isNaN(date.getTime())) {
        return '';
    }

    return new Intl.DateTimeFormat('de-DE', {
        timeZone: 'Europe/Berlin',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    }).format(date).replace(',', '');
}
